import { RegisterWayType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const registerWayName: { [key in RegisterWayType]: TKeyType } = {
  [RegisterWayType.MANUAL]: 'registerWay.manual',
  [RegisterWayType.AUTO]: 'registerWay.auto'
}

export default registerWayName
